import AuthService from './AuthService';

let instance;

export default function AuthServiceProvider() {
  if (!instance) {
    instance = new AuthService();
  }

  return instance;
}



// WEBPACK FOOTER //
// ./src/api/auth/AuthServiceProvider.js